import {Box as MUIBox, BoxProps as MUIBoxProps} from '@mui/material'
import React from 'react'

interface BoxProps extends MUIBoxProps {}

export const Box: React.FC<BoxProps> = (props) => {
  return <MUIBox {...props} />
}
